import { IUser } from 'src/app/store/interfaces/user.interface';

export interface IGlobalConfigState {
    isWaiting: boolean;
    user: IUser;
}

export const initialGlobalConfigState: IGlobalConfigState={
    isWaiting:false,
    user:null
}
